module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Triaz PR","short_name":"Triaz PR","display":"standalone","start_url":"/","background_color":"#ffffff","theme_color":"#A78B4D","icon":"src/images/triazpr-icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"ec1cab7ed74f92744c4a4e6b25a75e35"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
